import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { IPriceLevelsFeature } from './price-levels.feature.state';
import { getFailures, getIsLoading, getPriceLevels } from './price-levels.selectors';

@Injectable()
export class PriceLevelsFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public modifiers$ = this.store.select(getPriceLevels);

  constructor(private store: Store<IPriceLevelsFeature>) {}
}
